import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spacer, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { SIGNUP_HELP_ENTRIES_URL } from 'constants/routes';
import { registerUser } from 'data/api/account';
import { getCaptchaVerification, verifyCaptcha } from 'data/api';
import * as selectors from 'state/auth/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getFingerprint } from 'libs/utils/fingerprint';
import { navigateToPage, reloadPage } from 'libs/utils/window';
import ContentLoader from 'components/ContentLoader';
import Captcha from 'components/Captcha';
import RegisterForm from '../RegisterForm';
import { useRegistrationTracking } from '../hooks/useRegistrationTracking';
import { useEmailCodeTest } from '../hooks/useEmailCodeTest';
import useSuccessUrl from '../hooks/useSuccessUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TRANSLATION_PREFIX = 'auth.email.register';

const EmailRegister = () => {
  const {
    0: isCaptchaVisible,
    1: setIsCaptchaVisible
  } = useState(false);
  const {
    0: isCaptchaResolved,
    1: setIsCaptchaResolved
  } = useState(false);
  const {
    0: uuid,
    1: setUuid
  } = useState('');
  const {
    0: error,
    1: setError
  } = useState('');
  const {
    0: formData,
    1: setFormData
  } = useState();
  const translate = useTranslate(TRANSLATION_PREFIX);
  const referrerId = useSelector(selectors.getReferrerId);
  const trackRegistrationEvents = useRegistrationTracking();
  const isRegistrationCaptchaEnabled = useSelector(getIsFeatureSwitchEnabled('registration_captcha_enabled'));
  const {
    handleEmailCodeTest
  } = useEmailCodeTest();
  const successUrl = useSuccessUrl();

  async function performRegistration(data, _uuid) {
    const fingerprint = await getFingerprint();
    const response = await registerUser(_objectSpread(_objectSpread({
      agreeRules: true,
      password: ''
    }, data), {}, {
      referrerId,
      fingerprint,
      uuid: _uuid
    }));
    await trackRegistrationEvents({
      response,
      authType: 'internal',
      email: data.email
    });
    return response;
  }

  async function handleCaptchaComplete(key) {
    if (!formData) return;
    setIsCaptchaResolved(true);
    const verifyResponse = await verifyCaptcha({
      uuid,
      captchaToken: key
    });

    if ('errors' in verifyResponse || !verifyResponse.verified) {
      reloadPage();
      return;
    }

    const registrationResponse = await performRegistration(formData, verifyResponse.uuid);

    if ('errors' in registrationResponse) {
      setError(registrationResponse.message);
      setIsCaptchaVisible(false);
      setIsCaptchaResolved(false);
      return;
    }

    const emailCodeTestUrl = await handleEmailCodeTest(registrationResponse.user.id);
    navigateToPage(emailCodeTestUrl || successUrl);
  }

  async function handleFormSubmit(data) {
    setFormData(data);
    if (!isRegistrationCaptchaEnabled) return performRegistration(data);
    const captchaResponse = await getCaptchaVerification({
      entityType: 'registration',
      payload: {
        username: data.login,
        email: data.email
      }
    });
    if ('errors' in captchaResponse) return null;

    if (!captchaResponse.verified) {
      setUuid(captchaResponse.uuid);
      setIsCaptchaVisible(true);
      return null;
    }

    return performRegistration(data, captchaResponse.uuid);
  }

  function renderDescription() {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-ui-margin-horizontal-large",
      children: [/*#__PURE__*/_jsx(Text, {
        id: "auth_modal_title",
        text: translate('title'),
        type: Text.Type.Heading,
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), error ? /*#__PURE__*/_jsx(Text, {
        text: error,
        theme: "warning",
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center
      }) : null]
    });
  }

  if (isCaptchaVisible) {
    return /*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-large",
      children: isCaptchaResolved ? /*#__PURE__*/_jsx("div", {
        className: "u-ui-padding-bottom-x2-large",
        children: /*#__PURE__*/_jsx(ContentLoader, {
          styling: ContentLoader.Styling.Wide
        })
      }) : /*#__PURE__*/_jsx(Captcha, {
        onComplete: handleCaptchaComplete
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderDescription(), /*#__PURE__*/_jsx(RegisterForm, {
      isPasswordRequired: true,
      onSubmit: handleFormSubmit
    }), /*#__PURE__*/_jsxs("div", {
      className: "u-ui-margin-horizontal-large",
      children: [/*#__PURE__*/_jsx(Text, {
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center,
        children: /*#__PURE__*/_jsx("a", {
          href: SIGNUP_HELP_ENTRIES_URL,
          children: translate('actions.help')
        })
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      })]
    })]
  });
};

export default EmailRegister;